"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _select_styles = _interopRequireDefault(require("./select_styles"));

var _validation = require("../validation");

var _field = _interopRequireDefault(require("../field"));

var _field_helpers = require("../field_helpers");

var _select_definition = _interopRequireDefault(require("./select_definition"));

var _definecomponent = require("../../../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/* ========== ~~~~~~~~~~ EXPORT : FORM : FIELD : SELECT ~~~~~~~~~~ ========== */


var SelectField =
/*#__PURE__*/
function (_Component) {
  _inherits(SelectField, _Component);

  function SelectField(props) {
    var _this;

    _classCallCheck(this, SelectField);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelectField).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (e) {
      if (_this.props.handleBlur) _this.props.handleBlur(e); // VALIDATION OCCURS HERE

      _this.triggerOnBlurValidation(e.target.value);
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (e) {
      _this.setState({
        active: true
      });

      if (_this.props.handleFocus) _this.props.handleFocus(e);
    });

    _defineProperty(_assertThisInitialized(_this), "triggerOnUpdateValidation", function (fieldValue) {
      if (_this.props.type === 'select' || _this.props.validateOnChange || (0, _field_helpers._shouldValidateOnSignIn)(_this.props, fieldValue)) (0, _field_helpers.handleValidation)(_this.props, fieldValue);
    });

    _defineProperty(_assertThisInitialized(_this), "triggerOnBlurValidation", function (fieldValue) {
      (0, _field_helpers.handleValidation)(_this.props, fieldValue);

      _this.setState({
        active: false,
        hasValue: !!fieldValue
      });
    });

    _this.state = {
      active: false,
      hasValue: !!_this.props.defaultValue
    };
    return _this;
  }

  _createClass(SelectField, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // CONTINUOUS VALIDATION OCCURS HERE
      if (this.props.value !== prevProps.value) this.triggerOnUpdateValidation(this.props.value);
    }
  }, {
    key: "render",
    /////  ~~~~~~~~~~~ ---------- ~~~~~~~~~~~~  RENDER  ~~~~~~~~~~~ ---------- ~~~~~~~~~~~~  /////
    value: function render() {
      var _this2 = this;

      var selectfield = _react.default.createElement("select", {
        className: "select ".concat(this.props.classes.select),
        type: "text",
        name: this.props.name,
        value: this.props.value,
        readOnly: this.props.readOnly ? this.props.readOnly : false,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onChange: function onChange(e) {
          return (0, _field_helpers.handleChange)(_this2.props, e);
        },
        disabled: this.props.disabled
      }, _react.default.createElement("option", {
        name: '',
        value: '',
        disabled: true
      }, !!this.props.dummyOptionText ? this.props.dummyOptionText : 'Select your option'), this.props.options.map(function (option, index) {
        return _react.default.createElement("option", {
          key: index,
          name: option.name,
          value: option.value
        }, option.text);
      }));

      return _react.default.createElement(_field.default, _extends({}, this.props, {
        errorMessage: (0, _field_helpers.getErrorMessage)(this.props.name),
        active: this.state.active,
        valid: this.props.valid,
        hasValue: this.state.hasValue,
        component: selectfield
      }));
    }
  }]);

  return SelectField;
}(_react.Component);

;
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */

(0, _definecomponent.defineComponent)(SelectField, _select_definition.default, false);

var _default = (0, _reactJss.default)(_select_styles.default)(SelectField);

exports.default = _default;